import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {Colxx} from '../components/common/CustomBootstrap';
import {reactTableText} from '../constants/configs';
import {keyBy, mapValues, omit} from 'lodash';
import moment from 'moment';
import Api from '../services/Api';
import {
  i18nizeDate,
  getDatePickerProps,
  mapStatus,
  getStatusColor,
  mapTicketDepartment,
} from '../helpers/Utils';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import JalaliUtils from '@date-io/jalaali';
import MomentUtils from '@date-io/moment';
import i18n from '../services/i18n';
import {Link} from 'react-router-dom';
import fa_IR from "../constants/locales";

class Tickets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tickets: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
    };
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/tickets',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            userId: this.props.userId,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        tickets: data.tickets.map(ticket => ticket[0]),
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  getColumns = t => [
    {
      Header: t('Title'),
      accessor: 'title',
    },
    {
      Header: t('Department'),
      accessor: 'section',
      filterable: true,
      width: 130,
      Filter: ({filter, onChange}) => (
        <select
          style={{width: '100%'}}
          value={filter ? filter.value : t('all')}
          onChange={event => onChange(event.target.value)}
        >
          <option value="">{t('all')}</option>
          <option value="CUSTOMER_SUPPORT">{mapTicketDepartment('CUSTOMER_SUPPORT')}</option>
          <option value="TECHNICAL">{mapTicketDepartment('TECHNICAL')}</option>
          <option value="MANAGEMENT">{mapTicketDepartment('MANAGEMENT')}</option>
        </select>
      ),
      Cell: props => <span>{mapTicketDepartment(props.value)}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      width: 130,
      Filter: ({filter, onChange}) => (
        <select
          style={{width: '100%'}}
          value={filter ? filter.value : t('all')}
          onChange={event => onChange(event.target.value)}
        >
          <option value="">{t('all')}</option>
          <option value="PENDING">{mapStatus('WAITING')}</option>
          <option value="REPLIED">{mapStatus('REPLIED_OR_CLOSED')}</option>
        </select>
      ),
      Cell: props =>
        <span className={getStatusColor(props.value)}>
          {mapStatus(props.value === 'PENDING' ? 'REPLY_WAITING' : props.value)}
        </span>,
    },
    {
      Header: t('Register Date'),
      accessor: 'createdAt',
      filterable: true,
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      Filter: ({onChange}) => (
        <ThemeProvider theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          },
        })}>
          <MuiPickersUtilsProvider
            utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
            locale={i18n.language}
          >
            <DateTimePicker
              {...getDatePickerProps()}
              value={this.state.selectedStartDate}
              TextFieldComponent={props => <input style={{width: '100%'}} placeholder={t('start date')} {...props} />}
              onChange={date => {
                this.handleDateChange('selectedStartDate', date);
                onChange(date);
              }}
            />
            <div style={{height: 4}} />
            <DateTimePicker
              {...getDatePickerProps()}
              value={this.state.selectedEndDate}
              TextFieldComponent={props => <input style={{width: '100%'}} placeholder={t('end date')} {...props} />}
              onChange={date => {
                this.handleDateChange('selectedEndDate', date);
                onChange(date);
              }}
            />
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      ),
    },
    {
      Header: t('Update Date'),
      accessor: 'updatedAt',
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('View'),
      width: 80,
      Cell: props => <Link to={{
        pathname: '/dashboard/tickets/' + props.original.threadId,
        state: {
          ticket: props.original,
        },
      }}
      > <i className="simple-icon-eye view-icon"/> </Link>,
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary">
                {t('Tickets')}
              </CardTitle>
              <ReactTable
                manual
                ref={el => {this.table = el;}}
                className="-highlight"
                data={this.state.tickets}
                pages={this.state.pages}
                loading={this.state.loading}
                sortable={false}
                resizable={true}
                onFetchData={this.fetchData}
                columns={this.getColumns(t)}
                defaultPageSize={10}
                style={{
                  width: '100%'
                }}
                {...reactTableText}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(Tickets);
